import { withHandlers, compose, withProps } from 'recompose';
import { sendEventToSegment } from './index';
import * as events from './events';

const includeAnalytics = compose(
  withHandlers({
    sendEvent: () => (type, params) => {
      sendEventToSegment(type, { ...params });
    },
  }),
  withProps({ events })
);

export default includeAnalytics;
